import React, { useState, useEffect } from "react";
import { Button, Typography, Row, Pagination } from "antd";
import CommonCard from "./../Components/common/CardComponent";
import Footer from "../Components/layouts/Footer";
import Navbar from "../Components/layouts/Navbar";
import Page from "../Components/layouts/Page";
import { useNavigate } from "react-router-dom";
import { getPageById } from "../Api/index";
import "./../styles/pageTitle.css";

const NewsPage = () => {
  const navigate = useNavigate();
  const { Title } = Typography;

  const [newsData, setNewsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const pageSize = 6;

  useEffect(() => {
    const fetchNews = async (page) => {
      try {
        const response = await getPageById("6", page, pageSize);
        setNewsData(response.data);
        setTotalItems(response.total);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchNews(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNewsClick = (newsItemId) => {
    const clickedNewsItem = newsData.find((item) => item.id === newsItemId);
    navigate(`/ViewNews`, { state: { newsItem: clickedNewsItem } });
  };

  const showTotal = (total, range) => {
    return `${range[0]}-${range[1]} of ${total} items`;
  };

  return (
    <Page>
      <Navbar />
      <div className="page-wrapper">
        <div className="page-content woocommerce">
          <div className="container clear-fix">
            <div className="grid-col-row">
              <div className="site-card-border-less-wrapper">
                <div className="grid-col grid-col-12">
                  <div className="col2-set" id="customer_details">
                    <h1 className="section-title">News</h1>
                    <br />
                    <CommonCard
                      data={newsData}
                      onClick={(newsItem) => handleNewsClick(newsItem)}
                    />
                    <Row justify="center" style={{ marginTop: "20px" }}>
                      <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={totalItems}
                        onChange={handlePageChange}
                        showTotal={showTotal}
                        style={{ margin: "50px" }}
                      />
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </Page>
  );
};

export default NewsPage;
